<template>
  <base-stripe-table
    :headers="headers"
    :fetch-action="'listServices'"
    :items-getter="'getServices'"
    :pagination-getter="'getServicePagination'"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
          style="cursor: pointer;"
          @click="goto(item.id)"
        >
          <td>{{ item.name }}</td>
          <td v-date="item.created" />
        </tr>
      </tbody>
    </template>
  </base-stripe-table>
</template>
<script>
import BaseStripeTable from '@/components/Common/BaseStripeTable'

export default {
  components: {
    BaseStripeTable
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
        },

        {
          text: 'Created',
          sortable: false
        },
      ]
    }
  },
  methods: {
    goto(id) {
      this.$router.push({ name: 'service-detail', params: { id } })
    }
  },
}
</script>
